// State.js
// @flow
import * as _ from 'lodash';
import { observable, action } from 'mobx';
import { Api } from './Api';
import type { AppStateType, DataType } from './Types';
import { locale } from './Locale.js';
import helpers from './util/helpers';

if (helpers.findGetParameter('language')) {
  window.localStorage.setItem('language', helpers.findGetParameter('language'));
  window.localStorage.setItem('avatar', helpers.findGetParameter('avatar'));
}

export const state : AppStateType = observable({
  messages: {},
  locale: {},
  graphs: {
    useAvatars: false,
    useParticipantAvatar: true,
    jitter: false,
    sina: true,
    jitterAmount: 1.0,
    labelOffset: 60,
    showVisitBadges: true
  },
  language: window.localStorage.getItem('language') || 'en',
  avatar: window.localStorage.getItem('avatar') || 'face-1',//false,
  data: [],
  participantId: '',
  groups: {},
  headlines: [],
  benchmarks: [],
  chemicals: {},
  changeLanguage: action('changeLanguage', function(val) {
    this.language = val;
    helpers.eventLog("changeLanguage - " + val);
    if(val != '') window.localStorage.setItem('language', val);
  }),
  changeAvatar: action('changeAvatar', function(avatar) {
    this.avatar = avatar;
    if(avatar != '') window.localStorage.setItem('avatar', avatar);
  }),
  updateData: action('updateData', function(data, groups, chemicals, benchmarks) {
    this.data = data;
    this.groups = groups;
    this.chemicals = chemicals;
    this.benchmarks = benchmarks;
  }),
  updateHeadlines: action('updateHeadlines', function(headlines) {
    return this.headlines.replace(headlines);
  }),
  updateBenchmarks: action('updateBenchmarks', function(data) {
    this.benchmarks = data;
  }),
  updateStudyGroup: action('updateStudyGroup', function(studyGroup) {
    this.studyGroup = studyGroup;
    if (studyGroup.toLowerCase() == "poe") {
      this.showPOE = true;
    } else {
      this.showPOE = false;
    }
  }),
  updateLocale: action('updateLocale', function(data) {
    this.locale = data;
  }),
  updateMessages: action('updateMessages', function(data) {
    this.messages = data;
  }),
  toggleGraphAvatars: action('toggleGraphAvatars', function() {
    this.graphs.useAvatars = !this.graphs.useAvatars;
  }),

  loadMeasurements: action('loadMeasurements', function() {
    var compoundsURL = '/report/compounds.json?language='+locale;
    return Promise.all([
      Api.csv('/report/detections.csv'),
      Api.json(compoundsURL)
    ]).then((values) => {
      if(values[1].errors !== undefined) return Promise.reject("Load Data Error");
      const results = []
      const groups = {};
      const chemicals = {};

      const detections = values[0];
      const compounds = values[1];

      const benchmarks = [];


      _.values(compounds.compounds).forEach(function(compound) {
        compound.benchmarks.forEach(function(benchmark) {
          benchmarks.push({
            value: +benchmark.value,
            chemical_full: compound.name,
            chemical: compound.abbreviation === "" ? compound.name : compound.abbreviation,
            detected: benchmark.detected,
            name: benchmark.name,
            description: benchmark.description,
            medium: benchmark.medium,
            symbol: benchmark.symbol,
            unit: benchmark.unit,
          });
        });
      });

      let studyGroup;
      detections.forEach(function(row) {
        const compound = compounds.compounds[row.compound_id];
        row.compound_name = compound.name;
        if(!compound.abbreviation) {
        // if(compound.abbreviation === "") {
          row.abbreviation = compound.name;
        }
        else {
          row.abbreviation = compound.abbreviation;
        }

        if(groups[compound.group] === undefined) {
          groups[compound.group] = [];
        }

        if(chemicals[compound.group + "-" + row.abbreviation] === undefined) {
          chemicals[compound.group + "-" + row.abbreviation] = [];
        }

        // get study group
        if (row.mine === "t") {
          studyGroup = row.study_group
        }

        // XXX: ideally type DataType and BenchmarkType would be classes with methods
        _.times(parseInt(row.count), () => {
          const obj : DataType = {
            mine: row.mine === 't',
            chemical: row.abbreviation,
            chemical_full: row.compound_name,
            group: compound.group,
            value: +row.level,
            detected: row.detected === 't',
            visit: +row.batch,
            display_name: row.display_name,
            unit: row.unit,
          };

          results.push(obj);
          groups[compound.group].push(obj);
          chemicals[compound.group + "-" + row.abbreviation].push(obj);
        })
      });

      state.updateStudyGroup(studyGroup)
      state.updateData(results, groups, chemicals, benchmarks);

      return this;
    });
  }),
  loadHeadlines: action('loadHeadlines', function() {
    var headlinesURL = '/report/headlines.json?language=' + locale;
    return Api.json(headlinesURL).then((json) => {
      if(json.errors !== undefined) return Promise.reject("Load Headlines Error");
      state.updateHeadlines(json.headlines)
    });
  }),
  loggedIn: false, // TODO set to false before launching!
  logIn: action('logIn', function() {
    this.loggedIn = true;
  }),
  logOut: action('logOut', function() {
    this.loggedIn = false;
  }),
});

window.state = state;



// WEBPACK FOOTER //
// ./src/State.js